import AnyPageConfigurationSimpleForm from './AnyPageConfigurationSimpleForm'

export default AnyPageConfigurationSimpleForm
